import React,
{
  useState,
  useEffect,
  useCallback
}
from 'react';

import style from './index.module.scss';

/**
 * 右侧字母联动索引
 * @param {array} letters 右侧字母列表
 * @param {object} liRefList 左侧内容区DOM
 * @param {number} offsetTop 右侧字母区域浮层距顶部距离，默认值107
 * @param {number} letterH 单个字母高度, 默认值19
 * Note: 内容区 dom 需要手动设置 id="letter_A"
 */
const QuickJump = ({
  letters = [],
  liRefList = null,
  offsetTop = 107,
  letterH = 19,
  contentOffsetTop = 0, // 左侧内容区到顶部距离
}) => {
  // 当前高亮字母
  const [current, setCurrent] = useState('A');
  // 是否显示放大字母特效
  const [showBigLetter, setShowBigLetter] = useState(false);
  // 是否正在 touch 标记
  const [touchActive, setTouchActive] = useState(false);
  // 是否开启页面自动滚动监听
  let timerScroll = null;
  // 是否正在滚动内容区
  let isScroll = false;
  let prevClientY = 0;
  // 右侧字母区域浮层距顶部距离
  const startY = offsetTop;

  const jumpToCurrent = (event, type) => {
    const touchY = type === 'click' ? event.clientY : (event.changedTouches[0].clientY || event.changedTouches[0].pageY);
    if (prevClientY !== 0 && Math.abs(touchY - prevClientY) > 20) {
      return;
    }
    prevClientY = touchY;
    const index = Math.floor((touchY - startY) / letterH);
    if (index > letters.length - 1) {
      return;
    }
    if (index >= 0 && index <= letters.length) {
      setCurrent(letters[index]);
      jumpToSection(letters[index]);
    }
  }
  // 手动触发字母索引切换时
  const handleTouchStart = (event) => {
    // 禁止默认事件
    // event.preventDefault();
    event.stopPropagation();

    document.body.style.overflow = 'hidden';
    // 解绑滚动事件
    clearTimeout(timerScroll);
    window.removeEventListener('scroll', handleScroll, false);

    jumpToCurrent(event, event.type);
    // 跳转到当前选中字母
    setShowBigLetter(true);
    setTouchActive(true);
  }

  const handleMove = (event) => {
    // 禁止默认事件
    // event.preventDefault();
    event.stopPropagation();
    // 解绑滚动事件
    // clearTimeout(timerScroll);
    // window.removeEventListener('scroll', handleScroll, false);

    if (touchActive) jumpToCurrent(event);
  }

  const handleTouchEnd = () => {
    setTouchActive(false);
    prevClientY = 0;
    // 滚动结束后开启自动监听
    // document.addEventListener('scroll', () => {
      clearTimeout(timerScroll);
      timerScroll = setTimeout(() => {
        window.addEventListener('scroll', handleScroll, false);
        document.body.style.overflow = 'auto';
      }, 300);
    // });
  }

  // 滚动到内容区
  const scrollY = (x, y) => {
    var optionSupported = 'scrollBehavior' in document.documentElement.style;
    if (optionSupported) {
      window.scroll({
        // behavior: 'smooth',
        top: y,
        left: x
      });
    } else {
      window.scroll(x, y);
    }
  }

  // 滚动到内容区
  const jumpToSection = (letter) => {
    if (isScroll) {
      return;
    }
    isScroll = true;
    const element = document.getElementById(`letter_${letter}`);
    setTimeout(() => {
      scrollY(0, element.offsetTop - contentOffsetTop);
      isScroll = false;
    }, 30);
  }

  // 自动滚动时，切换字母索引高亮
  const handleScroll = useCallback(() => {
    setShowBigLetter(false);
    const domList = liRefList && liRefList.current;
    for (let i = 0; i < domList.length; i++) {
      const ele = domList[i];
      const eleTop = ele.getBoundingClientRect().top;
      if (eleTop > contentOffsetTop) {
        const idx = i === 0 ? i : (i - 1);
        if (domList[idx].id && domList[idx].id.slice(7)) {
          setCurrent(domList[idx].id.slice(7));
        }
        return;
      }
    }
  }, []);

  useEffect(() => {
    // 监听滚动
    window.addEventListener('scroll', handleScroll, false)
    return () => {
      window.removeEventListener('scroll', handleScroll, false)
    }
  }, []);

  if (!letters || letters.length === 0) {
    return null;
  }

  return (
    <div className={style["right-letter-nav"]}
    
      onTouchStart={(event) => handleTouchStart(event)}
      onClick={(event) => handleTouchStart(event)}
      onTouchMove={(event) => handleMove(event)}
      onTouchEnd={() => handleTouchEnd()}
    >
      <ul className={style["right-letter-nav__ul"]}>
        {
          letters.map((item) => (
            <li
              className={
                current === item
                  ? style["active"]
                  : style["right-letter-nav__li"]
              }
              key={item}
            >
              <span>{item}</span>
              <div className={
                current === item && showBigLetter
                  ? style["letter-highlight"]
                  : style["letter-hidden"]
              }>
                <span>{item}</span>
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default QuickJump;
